import templateUrl from "webmodals/lightbox.htm";
import basicController from "servicestack/basic.controller.properties";

export default {
  bindings: {
    lightbox: "<instance",
    title: "@lightboxTitle",
    subTitle: "@",
    hideHeader: "@",
    hideCloseButton: "@",
    hideFooter: "@",
    onDismiss: "&",
    onClose: "&",
    preventAutoHeight: "@",
  },
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
  transclude: {
    header: "?lightboxHeader",
    rawHeader: "?lightboxRawHeader",
    //title: '?lightboxTitle',
    body: "?lightboxBody",
    raw: "?lightboxRaw",
    rawFooter: "?lightboxRawFooter",
    footer: "?lightboxFooter",
  },
  controller($transclude) {
    let $ctrl = this;
    basicController($ctrl);
    $ctrl.isSlotFilled = (slot) => $transclude.isSlotFilled(slot);
    $ctrl.maxHeight = () => $ctrl.$pageConfig.height - 100;
  },
};
